import { render } from "./PortfolioManagement.vue?vue&type=template&id=593419f4&scoped=true"
import script from "./PortfolioManagement.vue?vue&type=script&lang=js"
export * from "./PortfolioManagement.vue?vue&type=script&lang=js"

import "./PortfolioManagement.vue?vue&type=style&index=0&id=593419f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593419f4"]])

export default __exports__